@if ( this.textControl.invalid && (this.textControl.dirty ||
this.textControl.touched)) { @if (this.textControl.errors?.['required']) {}
<div #container class="error-message-container">
  <div
    [style.display]="this.showMessageValue ? 'block' : 'none'"
    class="error-message"
  ></div>
  <div class="error-icon">
    <img src="svgs/icons/error.svg" alt="" />
    <div class="message">
      @if (this.textControl.errors?.['required']) {
      {{
        "validation.required"
          | translate : { value: (translationName | translate) }
      }}
      } @else if (this.textControl.errors?.['minlength']) {
      {{
      "validation.minLength"
      | translate
      : { value: (translationName | translate), length: this.textControl.errors?.['minlength'].requiredLength }
      }}
      } @else if (this.textControl.errors?.['maxlength']) {
      {{
      "validation.maxLength"
      | translate
      : { value: (translationName | translate), length: this.textControl.errors?.['maxlength'].requiredLength }
      }}
      } @else if (this.textControl.errors?.['email']) {
      {{ "validation.email" | translate }}
      } @else if (this.textControl.errors?.['requiresSpecialCharacters']) { }
      @else if (this.textControl.errors?.['decimal']) {
      {{ "validation.decimal" | translate }}
      } @else if (this.textControl.errors?.['requiresSpecialCharacters']) {
      {{ "validation.isContainsSpecialCharacter" | translate }}

      } @else if (this.textControl.errors?.['requiresNumbers']) {
      {{ "validation.isContainsNumber" | translate }}

      } @else if (this.textControl.errors?.['requiresLowercaseLetter']) {
      {{ "validation.isContainsLowercase" | translate }}

      } @else if (this.textControl.errors?.['requiresUppercaseLetter']) {
      {{ "validation.isContainsUppercase" | translate }}

      } @else if (this.textControl.errors?.['mismatch']) {
      {{ "login.form.match" | translate }}

      }
    </div>
  </div>
</div>
}
